import { useEffect, useRef, useState } from "react";

export function Reveal({ children, delay = 0, className = "", as: Tag = "div" }) {
  const ref = useRef(null);
  const [on, setOn] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el || !("IntersectionObserver" in window)) { setOn(true); return undefined; }
    const io = new IntersectionObserver(([e]) => { if (e.isIntersecting) { setOn(true); io.disconnect(); } }, { threshold: 0.1 });
    io.observe(el);
    return () => io.disconnect();
  }, []);
  return (
    <Tag ref={ref} className={`reveal ${on ? "reveal-on" : ""} ${className}`} style={delay ? { transitionDelay: `${delay}s` } : undefined}>
      {children}
    </Tag>
  );
}

export function SectionHead({ eyebrow, title, text, light = false, center = false, id }) {
  return (
    <Reveal className={`max-w-3xl ${center ? "mx-auto text-center" : ""}`}>
      {eyebrow && <span className={light ? "eyebrow-light" : "eyebrow"}><span className="h-px w-8 bg-gold" />{eyebrow}</span>}
      <h2 id={id} className={`mt-4 text-3xl font-semibold leading-[1.05] sm:text-4xl lg:text-5xl ${light ? "text-white" : ""}`}>{title}</h2>
      {text && <p className={`mt-4 text-base leading-relaxed md:text-lg ${light ? "text-zinc-300" : "text-body"}`}>{text}</p>}
    </Reveal>
  );
}
